import React, { SetStateAction, useState } from "react";
import { Article } from "../../services/coworkerApiCalls/Article/ArticlesTypes";
// eslint-disable-next-line import/no-extraneous-dependencies
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// eslint-disable-next-line import/no-extraneous-dependencies
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
// eslint-disable-next-line import/named
import { Link } from "react-router-dom";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import { Editor } from 'react-draft-wysiwyg';
import { createArticle, deleteArticle, updateArticle } from "../../services/coworkerApiCalls/Article/Article";
import { useOktaAuth } from "@okta/okta-react";
import { useDataApiCategories } from "../../Hooks/useDataCategoriesApi";
import { useDataSpacesApi } from "../../Hooks/useDataSpacesApi";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";

type ArticleCrudProperties = Article & {
  isRestaurant: boolean;
};

// Définition du type ArticleData
type ArticleData = {
  id: number;
  title: string;
  content: string;
  image: string;
  startDate: number;
  endDate: number;
  spaceId: number;
  categoryId: number;
  creationDate?: number; // Propriété optionnelle
  modificationDate?: number; // Propriété optionnelle
};


const ArticleCard: React.FC<Article> = ({ title, content, image }) => {
  return (
    <div className="w-96 rounded overflow-hidden shadow-lg bg-white">
      {image && <img className="w-48 object-cover mt-2" src={image} alt="Card" />}
      <div className="px-6 py-4 flex-grow">
        <h1 className="font-bold text-xl mb-2">{title}</h1>
        <div dangerouslySetInnerHTML={{ __html: content }} className="text-gray-700 text-justify" />
      </div>
    </div>
  );
};

const ArticleFull: React.FC<Article> = ({ title, content, image }) => {
  return (
    <div className="flex flex-col rounded overflow-hidden shadow-lg bg-white rootHome">
      {image && <img className="w-48 flex justify-end object-coverr mt-2" src={image} alt="Card" />}
      <div className="px-6 py-4 flex-grow">
        <h1 className="font-bold text-xl mb-2">{title}</h1>
        <article dangerouslySetInnerHTML={{ __html: content }} className="text-gray-700 text-justify" ></article>
      </div>
    </div>
  );
};


function onDelete(token: string, id: number) {
  const userConfirmed = confirm("êtes vous sur de vouloir supprimer ?")
  if (userConfirmed) {
    // L'utilisateur a confirmé, appeler la fonction deleteArticle
    void deleteArticle(token, id);
  }

}
const formatDate = (startDate: number, endDate: number): string => {
  const startingDate = new Date(startDate * 1000).toLocaleDateString('fr-FR');
  const endingDate = new Date(endDate * 1000).toLocaleDateString('fr-FR');
  return startingDate === endingDate ? startingDate : `Du ${startingDate} au ${endingDate}`;
};
const ArticleCrud: React.FC<ArticleCrudProperties> = ({ id, title, image, content, startDate, endDate, spaceId, categoryId, isRestaurant }) => {
  const { authState } = useOktaAuth();
  const allCategories = useDataApiCategories();
  const allSpaces = useDataSpacesApi();

  const idToken = authState!.idToken!.idToken
  return (

    <tr className="border-b border-gray-200">
      <td className="p-4"><strong className="text-gray-500"> {title} </strong></td>
      <td className="p-4"> <img className="w-24" src={image} alt={title} /></td>

      {
        isRestaurant ?
          (<>
            <td className="p-4"><div dangerouslySetInnerHTML={{ __html: content }}></div></td>
          </>)
          :

          (<>
            <td className="p-4">{formatDate(startDate, endDate)}</td>
            <td className="p-4">
              {allSpaces ? allSpaces.find(space => space.id === spaceId)?.name : 'Espaces en chargement...'}
            </td>
            <td className="p-4">
              {allCategories ? allCategories.find(category => category.id === categoryId)?.title : 'Catégories en chargement...'}
            </td>
            <td className="p-4 flex justify-end items-center">
              <Link to={`/edit-article/${id}`}>
                <button
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
                ><FontAwesomeIcon icon={faEdit} /></button>
              </Link>

              <button
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                onClick={() => onDelete(idToken, id)}
              ><FontAwesomeIcon icon={faTrashAlt} /></button>
            </td>
          </>)


      }

    </tr>
  )
}

const ArticleEdit: React.FC<Article> = ({ title, content, image, startDate, endDate, spaceId, categoryId, id, /*creationDate, modificationDate */ }) => {
  // eslint-disable-next-line unicorn/consistent-function-scoping
  const handleNavigation = (path: string) => {
    window.location.href = path; // Change l'URL et recharge la page
  };
  const delayNavigation = (path: string, delay: number) => {
    setTimeout(() => {
      handleNavigation(path);
    }, delay);
  };
  


  const contentBlock = htmlToDraft(content);
  const [bool, setBool] = useState<boolean>(true);
  const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(
    contentBlock.contentBlocks
  )));
  const [titleEdit, setTitleEdit] = useState(title)
  const [imageEdit, setImageEdit] = useState(image)
  const [startDateEdit, setStartDateEdit] = useState(startDate)
  const [endDateEdit, setEndDateEdit] = useState(endDate)
  const [spaceIdEdit, setspaceIdEdit] = useState(spaceId)
  const [categoryIdEdit, setcategoryIdEdit] = useState(categoryId)
  const [idEdit] = useState(id)

  const { authState } = useOktaAuth();
  const idToken = authState!.idToken!.idToken

  const allCategories = useDataApiCategories();
  const allSpaces = useDataSpacesApi();

  if (bool) {
    setEditorState(EditorState.createWithContent(editorState.getCurrentContent()))
    setBool(false)
  }

  const onEditorStateChange = (newEditorState: SetStateAction<EditorState>) => {
    

    setEditorState(newEditorState);
  };

  const handleSubmit = (event: React.FormEvent) => {

    event.preventDefault();
    
    const html = draftToHtml(convertToRaw(editorState.getCurrentContent()))
    
    const articleData: ArticleData = {
      id: idEdit, // L'ID de l'article à mettre à jour
      title: titleEdit,
      content: html,
      image: imageEdit,
      startDate: startDateEdit,
      endDate: endDateEdit,
      // Assurez-vous que ces états sont décommentés et correctement initialisés dans votre composant
      spaceId: spaceIdEdit, // ou le nom de la variable que vous utilisez pour l'ID de l'espace
      categoryId: categoryIdEdit, // ou le nom de la variable que vous utilisez pour l'ID de la catégorie
    };

    if (idEdit === 0) {
      // Ajout conditionnel des propriétés creationDate et modificationDate
      articleData.creationDate = 0; // Utilisez la date et l'heure actuelles pour la création
      articleData.modificationDate = 0; // Utilisez la date et l'heure actuelles pour la modification
      void createArticle(idToken, articleData)
      delayNavigation("/articles", 2000);
    } else {
      void updateArticle(idToken, articleData)
      delayNavigation("/articles", 2000);
    }

   
    // Ici, vous pouvez gérer la logique pour ajouter l'article (par exemple, envoi à une API)
  };

  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitleEdit(event.target.value);
  };
  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setImageEdit(event.target.value);
  };
  const handleSpaceIdChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setspaceIdEdit(Number.parseInt(event.target.value));
  };
  const handleCategoryIdChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setcategoryIdEdit(Number.parseInt(event.target.value));
  };
  const handleStartDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setStartDateEdit(Math.floor(new Date(event.target.value).getTime() / 1000));
  };
  const handleEndDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEndDateEdit(Math.floor(new Date(event.target.value).getTime() / 1000));
  };

  return (
    <form onSubmit={handleSubmit} action="/articles" className="flex flex-col gap-6 bg-white shadow-lg rounded-lg p-8">
      <h2 className="text-2xl font-semibold mb-5">
        {title ?
          <>Modifier </>
          :
          <>Ajouter </>
        }
        un Article
      </h2>
      <div className="form-group">
        <label htmlFor="title" className="text-lg font-semibold mb-2">Titre</label>
        <input
          type="text"
          name="title"
          value={titleEdit}
          onChange={handleTitleChange}
          placeholder="Title"
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
        />
      </div>

      <div className="editor-container flex flex-col">
        <label htmlFor="content" className="text-lg font-semibold mb-2">Contenu</label>
        <div className="editor border border-gray-300 rounded p-2">
          <div className='editor'>
            <Editor
              editorState={editorState}
              wrapperClassName="wrapper-class"
              editorClassName="editor-class"
              onEditorStateChange={onEditorStateChange}
              toolbarStyle={{
                position: 'sticky',
                top: 0,
                zIndex: 1000,
              }}
             
            />
          </div>
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="image" className="text-lg font-semibold mb-2">Image</label>
        <input
          type="text"
          name="image"
          value={imageEdit}
          onChange={handleImageChange}
          placeholder="Image URL"
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
        />
      </div>

      <div className="flex flex-wrap -mx-4 px-4">
        <div className="form-group w-full md:w-1/4">
          <label htmlFor="startDate" className="text-lg font-semibold mb-2">Date de Début</label>
          <input
            type="date"
            name="startDate"
            value={new Date(startDateEdit * 1000 + 2 * 3600 * 1000).toISOString().slice(0, 10)}
            onChange={handleStartDateChange}
            placeholder="Date de Début"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
          />
        </div>

        <div className="form-group w-full md:w-1/4">
          <label htmlFor="endDate" className="text-lg font-semibold mb-2">Date de Fin</label>
          <input
            type="date"
            name="endDate"
            value={new Date(endDateEdit * 1000 + 2 * 3600 * 1000).toISOString().slice(0, 10)}
            onChange={handleEndDateChange}
            placeholder="Date de Fin"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
          />
        </div>
      </div>


      {allSpaces &&
        <div className="form-group w-full md:w-1/2">
          <label htmlFor="spaceId" className="text-lg font-semibold mb-2">Espace de Coworking</label>
          <select
            name="spaceId"
            value={spaceIdEdit || ''}
            onChange={handleSpaceIdChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
          >
            {/* Ajouter une option par défaut pour encourager à choisir une catégorie */}
            <option value="">Aucun site spécifique</option>
            {allSpaces.map(category => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
            {/* Afficher une option supplémentaire si aucune catégorie n'est disponible */}
            {allSpaces.length === 0 && (
              <option value="" disabled>Aucun espace de coworking disponible</option>
            )}
          </select>
        </div>
      }

      {allCategories &&
        <div className="form-group w-full md:w-1/2">
          <label htmlFor="categoryId" className="text-lg font-semibold mb-2">Categorie de l'article</label>
          <select
            name="categoryId"
            value={categoryIdEdit || ''}
            onChange={handleCategoryIdChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
          >
            {/* Ajouter une option par défaut pour encourager à choisir une catégorie */}
            <option value="">Choisir la catégorie</option>
            {allCategories.map(category => (
              <option key={category.id} value={category.id}>
                {category.title}
              </option>
            ))}
            {/* Afficher une option supplémentaire si aucune catégorie n'est disponible */}
            {allCategories.length === 0 && (
              <option value="" disabled>Aucune catégorie disponible</option>
            )}
          </select>
        </div>
      }

      <button type="submit" className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        {title ?
          <>Modifier </>
          :
          <>Ajouter </>
        }
        l'Article
      </button>
    </form>
  );
};


export { ArticleCard, ArticleFull, ArticleCrud, ArticleEdit };